import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import { useDeleteCalcPanel } from "../hooks/useFetchData.hook";

const DeleteDialog = ({ open, handleClose, elementData, loadingDelete, setLoadingDelete, navigate }: any) => {
    const { deleteCalcPanel } = useDeleteCalcPanel();

    const handleDeleteCalc = async () => {
        setLoadingDelete(true);
        try {
            await deleteCalcPanel(elementData?.data?.url);
            navigate("/dashboard/calc");
        } catch (error) {
            console.error(error);
        } finally {
            setLoadingDelete(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Are you sure you want to delete {elementData?.data?.name} ({elementData?.data?.url})
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">This action is irreversible!</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button color="error" disabled={loadingDelete} onClick={handleDeleteCalc} autoFocus>
                    {loadingDelete ? "Loading..." : "Delete"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteDialog;
